import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const ReportListItem = ({ report, handleSelectedReport }) => (
	<Box
		onClick={() => handleSelectedReport(report)}
		sx={{
			backgroundColor: 'background.paper',
			display: 'flex',
			alignItems: 'flex-start',
			gap: '12px',
			padding: '10px 15px',
			borderBottom: '0.5px solid',
			borderColor: 'border.light',
			cursor: 'pointer',
			transition: 'background-color 0.2s',
			'&:hover': {
				backgroundColor: 'background.subtle',
			},
		}}
	>
		{/* Main Content */}
		<Box sx={{ flex: 1, minWidth: 0 }}>
			<Box>
				<Typography
					sx={{
						fontSize: '13px',
						fontWeight: 600,
						color: 'text.primary',
						mb: 0.5,
					}}
				>
					{report.name}
				</Typography>
				<Typography
					sx={{
						fontSize: '10px',
						color: 'text.secondary',
					}}
				>
					{report.folder_name ? `In ${report.folder_name}` : ''}
				</Typography>
			</Box>
		</Box>
	</Box>
);

ReportListItem.propTypes = {
	report: PropTypes.object.isRequired,
	handleSelectedReport: PropTypes.func.isRequired,
};

export default ReportListItem;
